import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _1d32f106 = () => interopDefault(import('..\\pages\\about\\index.vue' /* webpackChunkName: "pages/about/index" */))
const _c6675d52 = () => interopDefault(import('..\\pages\\appmalf-sdk\\index.vue' /* webpackChunkName: "pages/appmalf-sdk/index" */))
const _309d2c4f = () => interopDefault(import('..\\pages\\apps\\index.vue' /* webpackChunkName: "pages/apps/index" */))
const _e92f786e = () => interopDefault(import('..\\pages\\authentication\\index.vue' /* webpackChunkName: "pages/authentication/index" */))
const _db7c705a = () => interopDefault(import('..\\pages\\cli\\index.vue' /* webpackChunkName: "pages/cli/index" */))
const _102c7bd8 = () => interopDefault(import('..\\pages\\combo-sdk\\index.vue' /* webpackChunkName: "pages/combo-sdk/index" */))
const _6334eae8 = () => interopDefault(import('..\\pages\\commitment\\index.vue' /* webpackChunkName: "pages/commitment/index" */))
const _644d65c6 = () => interopDefault(import('..\\pages\\compliance\\index.vue' /* webpackChunkName: "pages/compliance/index" */))
const _e9574aea = () => interopDefault(import('..\\pages\\consulting\\index.vue' /* webpackChunkName: "pages/consulting/index" */))
const _8f0c87a0 = () => interopDefault(import('..\\pages\\custom\\index.vue' /* webpackChunkName: "pages/custom/index" */))
const _31bf1417 = () => interopDefault(import('..\\pages\\data\\index.vue' /* webpackChunkName: "pages/data/index" */))
const _2b469a71 = () => interopDefault(import('..\\pages\\deleteAccount\\index.vue' /* webpackChunkName: "pages/deleteAccount/index" */))
const _1569d0c4 = () => interopDefault(import('..\\pages\\edge-security-acceleration\\index.vue' /* webpackChunkName: "pages/edge-security-acceleration/index" */))
const _5fd813d0 = () => interopDefault(import('..\\pages\\forget-password\\index.vue' /* webpackChunkName: "pages/forget-password/index" */))
const _542e2942 = () => interopDefault(import('..\\pages\\game-sdk\\index.vue' /* webpackChunkName: "pages/game-sdk/index" */))
const _7220fb3b = () => interopDefault(import('..\\pages\\high-bandwidth\\index.vue' /* webpackChunkName: "pages/high-bandwidth/index" */))
const _a59c0972 = () => interopDefault(import('..\\pages\\information\\index.vue' /* webpackChunkName: "pages/information/index" */))
const _0112744c = () => interopDefault(import('..\\pages\\inquiry\\index.vue' /* webpackChunkName: "pages/inquiry/index" */))
const _c2118abc = () => interopDefault(import('..\\pages\\intranet\\index.vue' /* webpackChunkName: "pages/intranet/index" */))
const _5f79749e = () => interopDefault(import('..\\pages\\management\\index.vue' /* webpackChunkName: "pages/management/index" */))
const _45d7d451 = () => interopDefault(import('..\\pages\\mobile-network-sdk\\index.vue' /* webpackChunkName: "pages/mobile-network-sdk/index" */))
const _352075b8 = () => interopDefault(import('..\\pages\\network-equipment\\index.vue' /* webpackChunkName: "pages/network-equipment/index" */))
const _7d55e362 = () => interopDefault(import('..\\pages\\nodes\\index.vue' /* webpackChunkName: "pages/nodes/index" */))
const _e1e769a4 = () => interopDefault(import('..\\pages\\plugin\\index.vue' /* webpackChunkName: "pages/plugin/index" */))
const _2f30302a = () => interopDefault(import('..\\pages\\privacy\\index.vue' /* webpackChunkName: "pages/privacy/index" */))
const _ab9752c6 = () => interopDefault(import('..\\pages\\products\\index.vue' /* webpackChunkName: "pages/products/index" */))
const _665a2878 = () => interopDefault(import('..\\pages\\promise\\index.vue' /* webpackChunkName: "pages/promise/index" */))
const _3a26722b = () => interopDefault(import('..\\pages\\quality-monitoring\\index.vue' /* webpackChunkName: "pages/quality-monitoring/index" */))
const _085ce329 = () => interopDefault(import('..\\pages\\realtime-sdk\\index.vue' /* webpackChunkName: "pages/realtime-sdk/index" */))
const _4ee2e160 = () => interopDefault(import('..\\pages\\record\\index.vue' /* webpackChunkName: "pages/record/index" */))
const _2bf5f44c = () => interopDefault(import('..\\pages\\satisfaction-improvement\\index.vue' /* webpackChunkName: "pages/satisfaction-improvement/index" */))
const _25d18e7e = () => interopDefault(import('..\\pages\\settings\\index.vue' /* webpackChunkName: "pages/settings/index" */))
const _7482d280 = () => interopDefault(import('..\\pages\\smpro\\index.vue' /* webpackChunkName: "pages/smpro/index" */))
const _44c3e73a = () => interopDefault(import('..\\pages\\speedtest\\index.vue' /* webpackChunkName: "pages/speedtest/index" */))
const _411aeaa8 = () => interopDefault(import('..\\pages\\speedtest-deployment\\index.vue' /* webpackChunkName: "pages/speedtest-deployment/index" */))
const _29dd282d = () => interopDefault(import('..\\pages\\speedtest-sdk\\index.vue' /* webpackChunkName: "pages/speedtest-sdk/index" */))
const _12682acc = () => interopDefault(import('..\\pages\\terms\\index.vue' /* webpackChunkName: "pages/terms/index" */))
const _0c068926 = () => interopDefault(import('..\\pages\\testing-services\\index.vue' /* webpackChunkName: "pages/testing-services/index" */))
const _780dc14b = () => interopDefault(import('..\\pages\\video-sdk\\index.vue' /* webpackChunkName: "pages/video-sdk/index" */))
const _6d4829f7 = () => interopDefault(import('..\\pages\\web-open-speed-sdk\\index.vue' /* webpackChunkName: "pages/web-open-speed-sdk/index" */))
const _01fc4999 = () => interopDefault(import('..\\pages\\whole-home-wifi-sdk\\index.vue' /* webpackChunkName: "pages/whole-home-wifi-sdk/index" */))
const _55b2b912 = () => interopDefault(import('..\\pages\\wifi-analysis-sdk\\index.vue' /* webpackChunkName: "pages/wifi-analysis-sdk/index" */))
const _55774eb4 = () => interopDefault(import('..\\pages\\deleteAccount\\terms.vue' /* webpackChunkName: "pages/deleteAccount/terms" */))
const _4569f512 = () => interopDefault(import('..\\pages\\products\\cli\\index.vue' /* webpackChunkName: "pages/products/cli/index" */))
const _59ad8f17 = () => interopDefault(import('..\\pages\\products\\high-bandwidth\\index.vue' /* webpackChunkName: "pages/products/high-bandwidth/index" */))
const _0106e37e = () => interopDefault(import('..\\pages\\products\\intranet\\index.vue' /* webpackChunkName: "pages/products/intranet/index" */))
const _d12f09ec = () => interopDefault(import('..\\pages\\products\\plugin\\index.vue' /* webpackChunkName: "pages/products/plugin/index" */))
const _d31a93c6 = () => interopDefault(import('..\\pages\\products\\sdk\\index.vue' /* webpackChunkName: "pages/products/sdk/index" */))
const _de0d1dc6 = () => interopDefault(import('..\\pages\\products\\speedtest-package.vue' /* webpackChunkName: "pages/products/speedtest-package" */))
const _100739ea = () => interopDefault(import('..\\pages\\products\\speedtest-package-overcount.vue' /* webpackChunkName: "pages/products/speedtest-package-overcount" */))
const _393140a4 = () => interopDefault(import('..\\pages\\settings\\close.vue' /* webpackChunkName: "pages/settings/close" */))
const _1ccacf4a = () => interopDefault(import('..\\pages\\wwzs\\enterprise.vue' /* webpackChunkName: "pages/wwzs/enterprise" */))
const _4a6fa366 = () => interopDefault(import('..\\pages\\products\\cli\\data\\index.vue' /* webpackChunkName: "pages/products/cli/data/index" */))
const _968eb7f4 = () => interopDefault(import('..\\pages\\products\\cli\\document.vue' /* webpackChunkName: "pages/products/cli/document" */))
const _4ea31cf3 = () => interopDefault(import('..\\pages\\products\\cli\\download.vue' /* webpackChunkName: "pages/products/cli/download" */))
const _4b44ffed = () => interopDefault(import('..\\pages\\products\\high-bandwidth\\data\\index.vue' /* webpackChunkName: "pages/products/high-bandwidth/data/index" */))
const _f8b39334 = () => interopDefault(import('..\\pages\\products\\high-bandwidth\\document.vue' /* webpackChunkName: "pages/products/high-bandwidth/document" */))
const _180b349f = () => interopDefault(import('..\\pages\\products\\intranet\\document.vue' /* webpackChunkName: "pages/products/intranet/document" */))
const _646de9a0 = () => interopDefault(import('..\\pages\\products\\plugin\\data\\index.vue' /* webpackChunkName: "pages/products/plugin/data/index" */))
const _1eede193 = () => interopDefault(import('..\\pages\\products\\plugin\\document.vue' /* webpackChunkName: "pages/products/plugin/document" */))
const _70b64a73 = () => interopDefault(import('..\\pages\\products\\sdk\\data\\index.vue' /* webpackChunkName: "pages/products/sdk/data/index" */))
const _667e69a0 = () => interopDefault(import('..\\pages\\products\\sdk\\document.vue' /* webpackChunkName: "pages/products/sdk/document" */))
const _0068e28d = () => interopDefault(import('..\\pages\\products\\sdk\\download.vue' /* webpackChunkName: "pages/products/sdk/download" */))
const _16963c5d = () => interopDefault(import('..\\pages\\products\\cli\\data\\download.vue' /* webpackChunkName: "pages/products/cli/data/download" */))
const _63e486bd = () => interopDefault(import('..\\pages\\products\\high-bandwidth\\data\\download.vue' /* webpackChunkName: "pages/products/high-bandwidth/data/download" */))
const _43f85c2a = () => interopDefault(import('..\\pages\\products\\plugin\\data\\download.vue' /* webpackChunkName: "pages/products/plugin/data/download" */))
const _c2983312 = () => interopDefault(import('..\\pages\\products\\sdk\\data\\download.vue' /* webpackChunkName: "pages/products/sdk/data/download" */))
const _4ca6ea7e = () => interopDefault(import('..\\pages\\index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/about",
    component: _1d32f106,
    name: "about"
  }, {
    path: "/appmalf-sdk",
    component: _c6675d52,
    name: "appmalf-sdk"
  }, {
    path: "/apps",
    component: _309d2c4f,
    name: "apps"
  }, {
    path: "/authentication",
    component: _e92f786e,
    name: "authentication"
  }, {
    path: "/cli",
    component: _db7c705a,
    name: "cli"
  }, {
    path: "/combo-sdk",
    component: _102c7bd8,
    name: "combo-sdk"
  }, {
    path: "/commitment",
    component: _6334eae8,
    name: "commitment"
  }, {
    path: "/compliance",
    component: _644d65c6,
    name: "compliance"
  }, {
    path: "/consulting",
    component: _e9574aea,
    name: "consulting"
  }, {
    path: "/custom",
    component: _8f0c87a0,
    name: "custom"
  }, {
    path: "/data",
    component: _31bf1417,
    name: "data"
  }, {
    path: "/deleteAccount",
    component: _2b469a71,
    name: "deleteAccount"
  }, {
    path: "/edge-security-acceleration",
    component: _1569d0c4,
    name: "edge-security-acceleration"
  }, {
    path: "/forget-password",
    component: _5fd813d0,
    name: "forget-password"
  }, {
    path: "/game-sdk",
    component: _542e2942,
    name: "game-sdk"
  }, {
    path: "/high-bandwidth",
    component: _7220fb3b,
    name: "high-bandwidth"
  }, {
    path: "/information",
    component: _a59c0972,
    name: "information"
  }, {
    path: "/inquiry",
    component: _0112744c,
    name: "inquiry"
  }, {
    path: "/intranet",
    component: _c2118abc,
    name: "intranet"
  }, {
    path: "/management",
    component: _5f79749e,
    name: "management"
  }, {
    path: "/mobile-network-sdk",
    component: _45d7d451,
    name: "mobile-network-sdk"
  }, {
    path: "/network-equipment",
    component: _352075b8,
    name: "network-equipment"
  }, {
    path: "/nodes",
    component: _7d55e362,
    name: "nodes"
  }, {
    path: "/plugin",
    component: _e1e769a4,
    name: "plugin"
  }, {
    path: "/privacy",
    component: _2f30302a,
    name: "privacy"
  }, {
    path: "/products",
    component: _ab9752c6,
    name: "products"
  }, {
    path: "/promise",
    component: _665a2878,
    name: "promise"
  }, {
    path: "/quality-monitoring",
    component: _3a26722b,
    name: "quality-monitoring"
  }, {
    path: "/realtime-sdk",
    component: _085ce329,
    name: "realtime-sdk"
  }, {
    path: "/record",
    component: _4ee2e160,
    name: "record"
  }, {
    path: "/satisfaction-improvement",
    component: _2bf5f44c,
    name: "satisfaction-improvement"
  }, {
    path: "/settings",
    component: _25d18e7e,
    name: "settings"
  }, {
    path: "/smpro",
    component: _7482d280,
    name: "smpro"
  }, {
    path: "/speedtest",
    component: _44c3e73a,
    name: "speedtest"
  }, {
    path: "/speedtest-deployment",
    component: _411aeaa8,
    name: "speedtest-deployment"
  }, {
    path: "/speedtest-sdk",
    component: _29dd282d,
    name: "speedtest-sdk"
  }, {
    path: "/terms",
    component: _12682acc,
    name: "terms"
  }, {
    path: "/testing-services",
    component: _0c068926,
    name: "testing-services"
  }, {
    path: "/video-sdk",
    component: _780dc14b,
    name: "video-sdk"
  }, {
    path: "/web-open-speed-sdk",
    component: _6d4829f7,
    name: "web-open-speed-sdk"
  }, {
    path: "/whole-home-wifi-sdk",
    component: _01fc4999,
    name: "whole-home-wifi-sdk"
  }, {
    path: "/wifi-analysis-sdk",
    component: _55b2b912,
    name: "wifi-analysis-sdk"
  }, {
    path: "/deleteAccount/terms",
    component: _55774eb4,
    name: "deleteAccount-terms"
  }, {
    path: "/products/cli",
    component: _4569f512,
    name: "products-cli"
  }, {
    path: "/products/high-bandwidth",
    component: _59ad8f17,
    name: "products-high-bandwidth"
  }, {
    path: "/products/intranet",
    component: _0106e37e,
    name: "products-intranet"
  }, {
    path: "/products/plugin",
    component: _d12f09ec,
    name: "products-plugin"
  }, {
    path: "/products/sdk",
    component: _d31a93c6,
    name: "products-sdk"
  }, {
    path: "/products/speedtest-package",
    component: _de0d1dc6,
    name: "products-speedtest-package"
  }, {
    path: "/products/speedtest-package-overcount",
    component: _100739ea,
    name: "products-speedtest-package-overcount"
  }, {
    path: "/settings/close",
    component: _393140a4,
    name: "settings-close"
  }, {
    path: "/wwzs/enterprise",
    component: _1ccacf4a,
    name: "wwzs-enterprise"
  }, {
    path: "/products/cli/data",
    component: _4a6fa366,
    name: "products-cli-data"
  }, {
    path: "/products/cli/document",
    component: _968eb7f4,
    name: "products-cli-document"
  }, {
    path: "/products/cli/download",
    component: _4ea31cf3,
    name: "products-cli-download"
  }, {
    path: "/products/high-bandwidth/data",
    component: _4b44ffed,
    name: "products-high-bandwidth-data"
  }, {
    path: "/products/high-bandwidth/document",
    component: _f8b39334,
    name: "products-high-bandwidth-document"
  }, {
    path: "/products/intranet/document",
    component: _180b349f,
    name: "products-intranet-document"
  }, {
    path: "/products/plugin/data",
    component: _646de9a0,
    name: "products-plugin-data"
  }, {
    path: "/products/plugin/document",
    component: _1eede193,
    name: "products-plugin-document"
  }, {
    path: "/products/sdk/data",
    component: _70b64a73,
    name: "products-sdk-data"
  }, {
    path: "/products/sdk/document",
    component: _667e69a0,
    name: "products-sdk-document"
  }, {
    path: "/products/sdk/download",
    component: _0068e28d,
    name: "products-sdk-download"
  }, {
    path: "/products/cli/data/download",
    component: _16963c5d,
    name: "products-cli-data-download"
  }, {
    path: "/products/high-bandwidth/data/download",
    component: _63e486bd,
    name: "products-high-bandwidth-data-download"
  }, {
    path: "/products/plugin/data/download",
    component: _43f85c2a,
    name: "products-plugin-data-download"
  }, {
    path: "/products/sdk/data/download",
    component: _c2983312,
    name: "products-sdk-data-download"
  }, {
    path: "/",
    component: _4ca6ea7e,
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
